module.exports = __webpack_public_path__ + "img/white_logo.135c1b1f.png";